var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-auto-complete",class:_vm.cssClass},[_c('span',{staticClass:"auto-complete-primary"},[_vm._v(_vm._s(_vm.description))]),_c('span',{staticClass:"auto-complete-secondary"},[_vm._v(_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }